module.exports = "/fonts/quark-bold.svg?369dfc408b8f70643cae2c109a3d5ae3";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/fonts/Quark/quark-bold.svg
// module id = 07nu
// module chunks = 0